// extracted by mini-css-extract-plugin
export default {"basket-btn":"MiniBasketButtons-Wb3Gx__basket-btn","basket-buttons":"MiniBasketButtons-l359u__basket-buttons"};